export default __webpack_public_path__ + "static/media/arrow-left-icon.7b2def3f.svg";